import { Box, Button, Grid, Typography } from "@mui/material";
import PlatformTile from "./PlatformTile";
import { ReactComponent as ShopifyIcon } from "../../../Assets/shopify.svg";
import { ReactComponent as HighImpactIcon } from "../../../Assets/HighImpactDealer.svg";
import { ReactComponent as BCIcon } from "../../../Assets/BigCommerce.svg";
import { ReactComponent as WPIcon } from "../../../Assets/wordpress.svg";
import { useState } from "react";
import { SetupType } from "../../../models/features/Integration/DmsSetup";
import { useDispatch } from "react-redux";
import { addSetupType } from "../../../redux/reducer/features/Integration/DmsSetupSlice";

const platforms = [
  {
    id: "bigCommerce",
    icon: <BCIcon />,
    setupType: SetupType.BigCommerce,
  },
  { id: "shopify", icon: <ShopifyIcon />, setupType: SetupType.Shopify },
  { id: "hiImpact", icon: <HighImpactIcon />, setupType: SetupType.HiImpact },
  { id: "wordPress", icon: <WPIcon />, setupType: SetupType.WordPress },
];
interface PlatformSelectorProps {
  handleNext: any;
}

const PlatformSelector: React.FunctionComponent<PlatformSelectorProps> = ({
  handleNext,
}) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<SetupType | null>(null);
  const handleSetSetupType = (type: SetupType) => {
    setSelected(type);
    dispatch(addSetupType({ setupType: type }));
  };
  return (
    <Box minHeight={"80vh"}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 0.5, mt: 2 }}>
        <Button
          size="small"
          variant="contained"
          onClick={handleNext}
          disabled={selected === null}
        >
          Next
        </Button>
      </Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
        gap={4}
        mt={4}
      >
        <Typography fontSize={"1.5rem"}>
          Choose a platform below to continue
        </Typography>
        <Grid container spacing={2} justifyContent="center">
          {platforms.map((p) => (
            <Grid item key={p.id}>
              <PlatformTile
                icon={p.icon}
                selected={selected === p.setupType}
                onClick={() => handleSetSetupType(p.setupType)}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
export default PlatformSelector;
